document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.wg-featured-equipment').forEach(section => {

    const grid = section.querySelector('.wg-featured-equipment__grid');

    if (!grid) return;

    /* ==========================================
       MOBILE SCROLL SHADOW
    ========================================== */

    if (window.innerWidth <= 767) {

      function updateScrollState() {

        const atEnd =
          grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;

        section.classList.toggle(
          'wg-featured-equipment--end',
          atEnd
        );

      }

      updateScrollState();

      grid.addEventListener('scroll', updateScrollState);

    }

  });

});